// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	MessageBar: 'message-bar',
	MessageBar1: 'message-bar-1',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
